<div 
  [class]="entryClasses.join(' ')" 
  [style]="appointment?.style"
  [title]="tooltipContent"
  (click)="onEntryClick()">
  {{ displayContent }}
</div>
